module.exports = __webpack_public_path__ + "img/l2sun.6493e752.svg";